import React, { Component } from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBRow,
    MDBCol,
    MDBIcon,
    toast,
    MDBCard,
    MDBCardBody,
} from "mdbreact";
import axios from "../../../axios";
import "react-multi-carousel/lib/styles.css";
import "react-day-picker/lib/style.css";
import dateFnsFormat from "date-fns/format";
import Data from "../../../components/SubscriberMgmt/CumulativeBandwidth/Datachart/datachart";
import AddProfile from "../../../components/SubscriberMgmt/AddProfile/AddProfile";
import DeviceDetails from "../../../components/SubscriberMgmt/DeviceInformation/DeviceDetails";
import { withTranslation } from "react-i18next";
import AllWifiKeysTable from "../../../components/SubscriberMgmt/KeyInformation/Datatables/AllWifiKeysMoreDetailsTable";
import PasswordConditions from "../../../components/SubscriberMgmt/PasswordValidator/PasswordConditions";
import LinearProgress from '@mui/material/LinearProgress';

class KeyManage extends Component {
    constructor(props) {
        super(props);
        console.log('🔵 KeyManageProfiles CONSTRUCTOR - keyID prop:', props.keyID);
        this.state = {
            toggleEdit: "disabled",
            showPassword: true,
            modalEditNickname: false,
            modalEditPassword: false,
            venueName: this.props.venueName,
            selectedKeyName:
                this.props.keyNameListArrayAll?.[0]?.[
                    this.props.selectedNetworkIndex
                ]?.["KeyTag"] || "",
            password: this.props.password,
            oldPassword: this.props.password,
            tag: this.props.keyNameListArrayAll?.[0]?.[
                this.props.selectedNetworkIndex
            ]?.["psk"]?.split(".")[1] || "",
            // addedOn: new Intl.DateTimeFormat("en-US", {
            // 	year: "numeric",
            // 	month: "numeric",
            // 	day: "numeric",
            // }).format(new Date(this.props.sortedKeys[this.props.selectedNetworkIndex]["dateAddedUTC.ISO8601"])),
            // recentUse:
            // 	this.props.sortedKeys[this.props.selectedNetworkIndex]["mostRecentUseUTC.ISO8601"] !== undefined
            // 		? new Intl.DateTimeFormat("en-US", {
            // 				year: "numeric",
            // 				month: "numeric",
            // 				day: "numeric",
            // 		  }).format(new Date(this.props.sortedKeys[this.props.selectedNetworkIndex]["mostRecentUseUTC.ISO8601"]))
            // 		: "",
            selectedName: null,
            category: [],
            name: [],
            data: [],
            dot: true,
            passwordInvalid: false,
            count: 0,
            submittingPSKReset: false,
        };
    }
    
    componentDidMount() {
        // Start checking WPA3 status and refresh if needed
        this.checkAndStartWPA3Refresh();
    }
    
    componentDidUpdate(prevProps) {
        // Log keyID changes
        if (prevProps.keyID !== this.props.keyID) {
            console.log('🔵 KeyManageProfiles componentDidUpdate - keyID changed!');
            console.log('  Previous keyID:', prevProps.keyID);
            console.log('  New keyID:', this.props.keyID);
        }
        
        if (prevProps.password !== this.props.password) {
            this.setState({ password: this.props.password });
        }
        
        // Always check WPA3 status when props that could affect it change
        const prevWPA3Status = this.getWPA3Status(prevProps);
        const currentWPA3Status = this.getWPA3Status(this.props);
        
        // Check if any data that affects WPA3 status has changed
        const dataChanged = prevProps.sortedKeys !== this.props.sortedKeys ||
                           prevProps.venueUnitPolicyInfo !== this.props.venueUnitPolicyInfo ||
                           prevProps.ssidName !== this.props.ssidName ||
                           prevProps.keyID !== this.props.keyID;
        
        // Check if WPA3 status changed
        const statusChanged = prevWPA3Status.configured !== currentWPA3Status.configured ||
                             prevWPA3Status.isWPA3 !== currentWPA3Status.isWPA3;
        
        if (dataChanged || statusChanged) {
            this.checkAndStartWPA3Refresh();
            
            // Force re-render to update indicator immediately if status became configured
            if (!prevWPA3Status.configured && currentWPA3Status.configured) {
                this.forceUpdate();
            }
        }
    }
    
    componentWillUnmount() {
        if (this.wpa3RefreshInterval) {
            clearInterval(this.wpa3RefreshInterval);
        }
    }
    
    getWPA3Status = (props) => {
        const status = { configured: false, timestamp: null, isWPA3: false };
        
        console.log('🔍 KeyManageProfiles getWPA3Status called');
        console.log('  sortedKeys:', props.sortedKeys);
        console.log('  ssidName:', props.ssidName);
        console.log('  keyID:', props.keyID);
        
        if (!props.sortedKeys || !Array.isArray(props.sortedKeys)) {
            console.log('  ❌ No sortedKeys array');
            return status;
        }
        
        // Find the network that matches the ssidName
        const network = props.sortedKeys.find(net => net && net.ssid === props.ssidName);
        
        if (!network) {
            console.log('  ❌ Network not found for ssidName:', props.ssidName);
            return status;
        }
        
        console.log('  ✅ Network found:', network.ssid);
        
        // Check if this network uses WPA3
        status.isWPA3 = network.AuthenticationMechanism === 'WPA3';
        console.log('  AuthenticationMechanism:', network.AuthenticationMechanism);
        console.log('  isWPA3:', status.isWPA3);
        
        if (!status.isWPA3) {
            console.log('  ⏭️  Not a WPA3 network, skipping R1 check');
            return status;
        }
        
        // Get the key data from the network
        const keyData = network[props.keyID];
        console.log('  Looking for keyID:', props.keyID);
        console.log('  keyData:', keyData);
        
        if (!keyData || !keyData.VenueUnitPolicies) {
            console.log('  ❌ No keyData or VenueUnitPolicies found');
            return status;
        }
        
        console.log('  ✅ VenueUnitPolicies:', keyData.VenueUnitPolicies);
        
        // Check all policies for R1ConfiguredUTC
        const policyKeys = Object.keys(keyData.VenueUnitPolicies);
        console.log('  Policy keys:', policyKeys);
        
        for (const policyKey of policyKeys) {
            const policy = keyData.VenueUnitPolicies[policyKey];
            console.log('  Checking policy:', policyKey, policy);
            
            if (policy && policy.NetworkData && policy.NetworkData.R1ConfiguredUTC) {
                status.configured = true;
                status.timestamp = policy.NetworkData.R1ConfiguredUTC;
                console.log('  ✅ R1ConfiguredUTC found:', status.timestamp);
                break;
            }
        }
        
        if (!status.configured) {
            console.log('  ❌ No R1ConfiguredUTC found in any policy');
        }
        
        return status;
    }

    getSelectedKeyData = (props) => {
        if (!props.sortedKeys || !Array.isArray(props.sortedKeys)) {
            return undefined;
        }

        const network = props.sortedKeys.find(net => net && net.ssid === props.ssidName);

        if (!network) {
            return undefined;
        }

        return network[props.keyID];
    }

    checkAndStartWPA3Refresh = () => {
        const wpa3Status = this.getWPA3Status(this.props);
        
        if (wpa3Status.isWPA3 && !wpa3Status.configured) {
            // Password not configured yet, start refresh interval
            this.startWPA3Refresh();
        } else {
            // Password is configured or not WPA3, stop refresh interval
            if (this.wpa3RefreshInterval) {
                clearInterval(this.wpa3RefreshInterval);
                this.wpa3RefreshInterval = null;
            }
        }
    }
    
    startWPA3Refresh = () => {
        // Clear any existing interval
        if (this.wpa3RefreshInterval) {
            clearInterval(this.wpa3RefreshInterval);
        }
        
        // Start new interval to refresh every 30 seconds
        this.wpa3RefreshInterval = setInterval(() => {
            console.log('🔄 Auto-refreshing keys for WPA3 status check...');
            if (this.props.listKeys) {
                this.props.listKeys();
            }
        }, 30000); // 30 seconds
    }
    toggleAddProfile = () => {
        this.setState({
            modalAddProfile: !this.state.modalAddProfile,
        });
    };
    toggleEditNickname = () => {
        this.setState({
            selectedKeyName: this.props.selectedKeyName,
            modalEditNickname: !this.state.modalEditNickname,
        });
    };
    toggleEditPassword = () => {
        this.setState({
            modalEditPassword: !this.state.modalEditPassword,
            password: this.state.password,
            count: 0,
            newpsk: "",
            lowercase: false,
            uppercase: false,
            charLength: false,
            number: false,
            specialChar: false,
            noConsecutiveRepeats: false,
            firstCharNotSpecial: false,
            maxLength: false,
            dot: true,
            updatedpsk: null,
        });
    };
    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };
    toggleEdit = () => {
        this.setState({ toggleEdit: !this.state.toggleEdit });
    };
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    submitEditNickname = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            KeyID: this.props.keyID,
            KeyTag: this.state.selectedKeyName,
        };
        axios
            .post("/subscriberconsole/updateKeyTag", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    modalEditNickname: !this.state.modalEditNickname,
                });
                toast.success("Nickname Updated", {
                    closeButton: false,
                });
                this.props.updateNameKeyProfile(
                    this.state.selectedKeyName,
                    this.props.keyID,
                    this.props.keyInfo,
                    this.state.password.split(".")[0],
                    this.state.tag
                );
            })
            .catch((error) => {
                this.setState({ error: true });
                toast.error("Nickname Not Updated", {
                    closeButton: false,
                });
            });
    };
    submitEditPassword = (currentKeyID) => {

        this.setState({
            submittingPSKReset: true,
        });
        if (this.state.password !== null) {
            let body;
            if (sessionStorage.getItem("showCustomPSK") === "true") {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    CurrentKeyID: currentKeyID,
                    NewKey: this.state.newpsk,
                };
            } else {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    CurrentKeyID: currentKeyID,
                    UserPartForNewKey: this.state.newpsk,
                }
            }
            axios
                .post("/subscriberconsole/resetKey", body, {
                    headers: {},
                })
                .then((response) => {
                    this.setState({
                        modalEditPassword: !this.state.modalEditPassword,
                        oldPassword: this.state.newpsk,
                        submittingPSKReset: false,
                    });
                    if (!toast.isActive(this.toastId)) {
                        toast.success(response.data.message, {
                            closeButton: false,
                        });
                    }
                    if (sessionStorage.getItem("showCustomPSK") === "true") {
                        this.props.updateNameKeyProfile(
                            this.props.selectedKeyName,
                            this.props.keyID,
                            this.props.keyInfo,
                            this.state.newpsk,
                            this.state.tag
                        );
                    } else {
                        this.props.updateNameKeyProfile(
                            this.props.selectedKeyName,
                            this.props.keyID,
                            this.props.keyInfo,
                            this.state.newpsk.split(".")[0],
                            this.state.tag
                        );
                    }
                })
                .catch((error) => {
                    this.setState({ error: true });
                    toast.error(error.response.data.message, {
                        closeButton: false,
                        submittingPSKReset: false,
                    });
                });
        } else {
            toast.error(
                "We encountered an error. Please reload the page and try again.",
                {
                    closeButton: false,
                }
            );
        }
    };
    formatDate(date, format, locale) {
        return dateFnsFormat(date, format, { locale });
    }
    setPassword = (newpassword, password, tag) => {
        let scrubbedPassword = newpassword.replace(/\./g, "");
        if(sessionStorage.getItem("showCustomPSK") === "true"){
         this.setState({ newpsk: scrubbedPassword });
        this.setState({ password: scrubbedPassword});
        }else{
         this.setState({ newpsk: scrubbedPassword });
        this.setState({ password: scrubbedPassword + "." + tag });
        }
        // console.log("🚀 ~ file: KeyInformation.js:245 ~ KeyInformation ~ newpassword:", scrubbedPassword)
        
        this.setState({ tag: tag });
        this.passwordValidate(scrubbedPassword);
    };
    copyPassword = () => {
        var copyText = document.getElementById("passwordHidden");
        var textArea = document.createElement("textarea");
        textArea.value = copyText.textContent;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        this.setState({ copyText: "Copied" });
        textArea.remove();
        toast.success("Password copied", {
            closeButton: false,
        });
    };
    renderDeviceIcon(param) {
        switch (param) {
            case "NetworkDevice":
                return "mobile-alt";
            case "Laptop":
                return "laptop";
            case "Unknown":
                return "question";
            default:
                return "mobile-alt";
        }
    }
    toggleDeviceDetails = (device) => {
        this.setState({
            modalDeviceDetails: !this.state.modalDeviceDetails,
            deviceDetails: device,
        });
    };
    toggleDeviceDetailsClose = () => {
        this.setState({
            modalDeviceDetails: !this.state.modalDeviceDetails,
        });
    };
    validateForm() {
        if (this.state.password !== null) {
            return this.state.password.split(".")[0].length >= 1;
        }
    }
    passwordValidate = (newpassword) => {
     const value = newpassword;
     const regexNum = /\d/;
     const regexLowercase = /[a-z]/;
     const regexUppercase = /[A-Z]/;
     const regexCharLength = /^.{8,}$/;
     const regexMaxLength = /^.{0,63}$/;
     const regexSpecialChar = /[!#+,\-/:=@_]/;
     const regexFirstCharSpecial = /^[!#+,\-/:=@_]/;
     const regexConsecutiveRepeats = /(.)\1{7,}/;
     const regexDot = /[.]/;
     const requiresSpecialChar = this.getSelectedKeyData(this.props)?.StrictPSK === true;
     // const userEmail = this.state.userEmail;
     // const userName = userEmail.split("@")[0];
     let count = 0;
     if (regexNum.test(value)===true){
      this.setState({ 
       number: true,
       count: count+1
      });
      count++;
     }else{
      this.setState({ number: false });
     }
     if (regexLowercase.test(value)===true){
      this.setState({ lowercase: true,
       count: count+1 });
      count++;
     }else{
      this.setState({ lowercase: false });
     }
     if (regexUppercase.test(value)===true){
      this.setState({ uppercase: true,
       count: count+1 });
      count++;
     }else{
      this.setState({ uppercase: false });
     }
     // if (regexSymbol.test(value)===true){
     //  this.setState({ symbol: false,
     //   count: count-1 });
     //  count--;
     // }else{
     //  this.setState({ symbol: true });
     // }
     
     if (regexCharLength.test(value)===true){
      this.setState({ charLength: true,
       count: count+1 });
      count++;
     }else{
      this.setState({ charLength: false });
     }
     if (regexMaxLength.test(value)===true){
      this.setState({ maxLength: true, count: requiresSpecialChar ? count+1 : count });
      if (requiresSpecialChar) count++;
     }else{
      this.setState({ maxLength: false });
     }
     if (regexSpecialChar.test(value)===true){
      this.setState({ specialChar: true, count: requiresSpecialChar ? count+1 : count });
      if (requiresSpecialChar) count++;
     }else{
      this.setState({ specialChar: false });
     }
     if (regexFirstCharSpecial.test(value)===false){
      this.setState({ firstCharNotSpecial: true, count: requiresSpecialChar ? count+1 : count });
      if (requiresSpecialChar) count++;
     }else{
      this.setState({ firstCharNotSpecial: false });
     }
     if (regexConsecutiveRepeats.test(value)===false){
      this.setState({ noConsecutiveRepeats: true, count: requiresSpecialChar ? count+1 : count });
      if (requiresSpecialChar) count++;
     }else{
      this.setState({ noConsecutiveRepeats: false });
     }
     if (regexDot.test(value)===true){
      this.setState({
       dot: false,
       count: count-1
      });
      count--;
     
    }else{
     this.setState({ dot: true });
    }
     if(count>=(requiresSpecialChar ? 8 : 4)){
      // Get first actual key ID, skipping metadata fields
      const allKeys = Object.keys(this.props.sortedKeys[0]);
      const validKeyID = allKeys.find(key => 
          key !== 'ssid' && 
          key !== 'DisplayOrder' && 
          key !== 'AuthenticationMechanism' && 
          key !== 'key' && 
          key !== 'editable'
      );
      
      let body = {
       "AccessToken": sessionStorage.getItem("AccessToken"),
       "CurrentKeyID": this.state.selectedKeyID !== undefined
       ? this.state.selectedKeyID
       : validKeyID,
       "NewKey": newpassword,
       "dryRun": true
      }
      // console.log(this.state)
      this.setState({
       loadingPasswordStrength: true
      })
      axios
          .post("/subscriberconsole/resetKey", body, { headers: {} })
          .then((response) => {
            if(response.data.message === "Strong Wi-Fi password. "){
             this.setState({
              count: count + 1,
              loadingPasswordStrength: false,
              passwordInvalid: false
             })
            }else{
             this.setState({
              // count: count - 1,
              loadingPasswordStrength: false,
              passwordInvalid: true
             })
            }
          })
          .catch((error) => {
            this.setState({ 
             error: true,
             loadingPasswordStrength: false, 
             passwordInvalid: true,
             count: count - 1,
            });
            // toast.error(t("profiledetails.passwordnotupdated"), {
            //   closeButton: false,
            // });
          });
     }
     // regexNum.test(value)
     //   ? (this.setState({ number: true }), count++)
     //   : this.setState({ number: false });
     // regexLowercase.test(value)
     //   ? this.setState({ lowercase: true })
     //   : this.setState({ lowercase: false });
     // regexUppercase.test(value)
     //   ? this.setState({ uppercase: true })
     //   : this.setState({ uppercase: false });
     // regexCharLength.test(value)
     //   ? this.setState({ charLength: true })
     //   : this.setState({ charLength: false });
     // !value.toLowerCase().includes(userName.toLowerCase())
     //   ? this.setState({ emailMatch: true })
     //   : this.setState({ emailMatch: false });
    };
    render() {
     // console.log(this.state)
        const { t } = this.props;
        let firstKeyID;
        let password;
        if (this.state.password !== null) {
            password = this.state.password;
        } else {
            password = this.props.firstPSK;
        }
        let keyNameListArray = this.props.keyNameListArray;
        if (
            this.props.venueName[0] !== undefined &&
            this.props.sortedKeys !== undefined
        ) {
            // Get first actual key ID, skipping metadata fields
            const allKeys = Object.keys(this.props.sortedKeys[0]);
            firstKeyID = allKeys.find(key => 
                key !== 'ssid' && 
                key !== 'DisplayOrder' && 
                key !== 'AuthenticationMechanism' && 
                key !== 'key' && 
                key !== 'editable'
            );
        }
        const requiresSpecialChar = this.getSelectedKeyData(this.props)?.StrictPSK === true;
        const localMaxCount = requiresSpecialChar ? 8 : 4;
        let passwordStrength;
        if(this.state.count<=localMaxCount/2){
         passwordStrength = "weak"
        }else if(this.state.count>localMaxCount/2 && this.state.count<=localMaxCount){
         passwordStrength = "average"
        }else{
         passwordStrength = "strong"
        }
        console.log("password: ", password)
        
        // Get WPA3 status using getWPA3Status method
        const wpa3Status = this.getWPA3Status(this.props);
        
        return (
            <>
                {/* <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={10000}
                /> */}
                <MDBModal
                    isOpen={this.state.modalAddProfile}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <AddProfile
                        toggleAddProfile={this.toggleAddProfile}
                        keyInfo={this.props.keyInfo}
                        ssidName={this.props.ssidName}
                        password={
                            this.props.password === null
                                ? this.props.firstPSK
                                : this.props.password
                        }
                        keyID={this.props.keyID}
                        updateNameKey={this.props.updateNameKey}
                        updateNameNetwork={this.props.updateNameNetwork}
                        SessionList={this.props.SessionList}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalDeviceDetails}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <DeviceDetails
                        toggleDeviceDetails={this.toggleDeviceDetailsClose}
                        deviceDetails={this.state.deviceDetails}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalEditNickname}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <MDBModalHeader toggle={this.toggleEditNickname}>
                        <h4>Edit Nickname</h4>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    Nickname
                                </label>
                                <input
                                    id="nickname"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    name="selectedKeyName"
                                    value={
                                        this.state.selectedKeyName === null
                                            ? this.props.firstKeyName
                                            : this.state.selectedKeyName
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid email.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn
                                color="danger"
                                onClick={this.submitEditNickname}
                            >
                                Submit
                            </MDBBtn>
                            <MDBBtn
                                color="danger"
                                onClick={this.toggleEditNickname}
                            >
                                Cancel
                            </MDBBtn>
                        </div>
                    </MDBModalBody>
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalEditPassword}
                    toggle={this.toggle}
                    size="lg"
                    className="form"
                >
                    <MDBModalHeader toggle={this.toggleEditPassword}>
                        <h4>Wi-Fi Password Reset</h4>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>
                            <MDBCol col="6">
                                <p>WARNING</p>
                                <p>
                                    Devices connected to this network will need
                                    to be reconfigured with the new password.
                                    Your old password will remain active for two
                                    hours. Upon expiration, devices using that
                                    password will lose the Wi-Fi connection.
                                </p>
                                <p>Please note, it will take up to 5 minutes for the new Wi-Fi password to activate and take effect.</p>
                                <div className="form-group row">
                                    <div className="col-sm-2">
                                        <p>Profile</p>
                                    </div>
                                    <div className="col-sm-6">
                                        {this.props.selectedKeyName}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-2">
                                        <p>Network</p>
                                    </div>
                                    <div className="col-sm-6">
                                        {this.props.ssidName}
                                    </div>
                                </div>
                                



                                {
                                 sessionStorage.getItem("showCustomPSK") === "false" 
                                 ? 
                                 <>
                                 <p className="wifiDisclaimer">
                                    Enter a new Personal Token below. Your Wi-Fi
                                    password is the combination of your personal
                                    token and your unique ID. For security
                                    purposes, the unique ID cannot be modified.
                                </p>
                                 <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text passwordLabel"
                                >
                                    Password
                                </label>
                                <input
                                    id="editpassword"
                                    className="form-control"
                                    onChange={(e) =>
                                        this.setPassword(
                                            e.target.value,
                                            password.split(".")[1] === undefined
                                                ? this.props.token
                                                : password.split(".")[1],
                                                this.props.token
                                        )
                                    }
                                    name="password"
                                    value={
                                        this.state.password === null
                                            ? this.props.firstPSK.split(".")[0]
                                            : this.state.password.split(".")[0]
                                    }
                                />
                                <span className="password_subscriber">
                                    .
                                    {this.state.password.split(".")[1] ===
                                    undefined
                                        ? this.props.token
                                        : this.state.password.split(".")[1]}
                                </span>
                                <div className="invalid-feedback">
                                    Please provide a valid password.
                                </div>
                                <br />
                                <br />
                                <p>New Wi-Fi Password</p>
                                <input
                                    id="editpassword2"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    name="password"
                                    value={
                                        this.state.tag !== undefined
                                            ? this.state.password.split(
                                                  "."
                                              )[0] +
                                              "." +
                                              this.state.tag
                                            : this.state.password.split(
                                                  "."
                                              )[1] === undefined
                                            ? this.state.password +
                                              "." +
                                              this.props.token
                                            : this.state.password
                                    }
                                />
                                </>
                                 : 
                                 <MDBRow>
                                    <MDBCol className="col-auto pr-3 editPassword">
                                        <label htmlFor="defaultFormLoginEmailEx" className="black-text passwordLabel">
                                            Old Wi-Fi Password
                                        </label>
                                        <input disabled id="editpassword" className="form-control" name="password" value={this.state.oldPassword === null
                                            ? this.props.firstPSK
                                            : this.state.oldPassword} />
                                        <br />
                                        <label htmlFor="defaultFormLoginEmailEx" className="black-text passwordLabel">
                                            New Wi-Fi Password
                                        </label>
                                        <input id="editpassword" className="form-control" onChange={(e) => this.setPassword(e.target.value, this.state.newpsk !== undefined ? this.state.newpsk : this.state.newpsk)} name="password" value={this.state.newpsk} />
                                        <br />
                                        <LinearProgress
                                            value={Math.max(0, Math.min((this.state.count / localMaxCount) * 100, 100))}
                                            // valueBuffer="100"
                                            variant="determinate"
                                            className={passwordStrength}
                                        />
                                        Your password strength is {passwordStrength}
                                    </MDBCol>
                                    <MDBCol className="col-auto pl-1">
                                        

                                        <label htmlFor="defaultFormLoginEmailEx" className="black-text passwordLabel bold">
                                            Password Requirements
                                        </label>
                                        <PasswordConditions
                                            id="editpassword"
                                            className="form-control"
                                            charLength={this.state.charLength}
                                            lowercase={this.state.lowercase}
                                            uppercase={this.state.uppercase}
                                            number={this.state.number}
                                            emailMatch={this.state.emailMatch}
                                            symbol={this.state.symbol}
                                            specialChar={this.state.specialChar}
                                            noConsecutiveRepeats={this.state.noConsecutiveRepeats}
                                            firstCharNotSpecial={this.state.firstCharNotSpecial}
                                            maxLength={this.state.maxLength}
                                            dot={this.state.dot}
                                            requiresSpecialChar={requiresSpecialChar}
                                        />
                                        {this.state.passwordInvalid ? (
                                            <label htmlFor="defaultFormLoginEmailEx" className="passwordLabel bold invalidPassword" id="invalidPassword">
                                                Our apologies, your chosen password is not valid. Please create a new password.
                                            </label>
                                        ) : (
                                            ""
                                        )}
                                    </MDBCol>
                                </MDBRow>
                                }







                                
                                
                                {/* <input
                                    id="editpassword"
                                    className="form-control"
                                    onChange={(e) =>
                                        this.setPassword(
                                            e.target.value,
                                            password.split(".")[1] === undefined
                                                ? this.props.token
                                                : password.split(".")[1]
                                        )
                                    }
                                    name="password"
                                    value={
                                        this.state.password === null
                                            ? this.props.firstPSK.split(".")[0]
                                            : this.state.password.split(".")[0]
                                    }
                                />
                                <span className="password_subscriber">
                                    .
                                    {this.state.password.split(".")[1] ===
                                    undefined
                                        ? this.props.token
                                        : this.state.password.split(".")[1]}
                                </span>
                                <div className="invalid-feedback">
                                    Please provide a valid password.
                                </div>
                                <br />
                                <br />
                                <p>New Wi-Fi Password</p>
                                <input
                                    id="editpassword2"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    name="password"
                                    value={
                                        this.state.tag !== undefined
                                            ? this.state.password.split(
                                                  "."
                                              )[0] +
                                              "." +
                                              this.state.tag
                                            : this.state.password.split(
                                                  "."
                                              )[1] === undefined
                                            ? this.state.password +
                                              "." +
                                              this.props.token
                                            : this.state.password
                                    }
                                /> */}
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn
                                color="danger"
                                disabled={
                                 (passwordStrength !== "strong" 
                                 && sessionStorage.getItem("showCustomPSK") === "true")
                                 || this.state.submittingPSKReset === true  || this.state.newpsk === ""
                                 ? true:false}
                                onClick={(e) =>
                                    this.submitEditPassword(
                                        this.state.selectedKeyID !== undefined
                                            ? this.state.selectedKeyID
                                            : firstKeyID
                                    )
                                }
                            >
                                Submit
                            </MDBBtn>
                            <MDBBtn
                                color="danger"
                                onClick={this.toggleEditPassword}
                            >
                                Cancel
                            </MDBBtn>
                        </div>
                    </MDBModalBody>
                </MDBModal>
                <MDBModalHeader toggle={this.props.toggleManageKey}>
                    <h4>Profile Details</h4>
                </MDBModalHeader>
                <MDBModalBody style={{ margin: "0px 20px 0px 10px" }}>
                    <MDBRow>
                        <MDBCol sm="6">
                            <div className="form-group row">
                                <div className="col-sm-4">
                                    <p>
                                        <strong>
                                            {t("profiledetails.profile")}
                                        </strong>
                                    </p>
                                </div>
                                <div className="col-sm-6">
                                    <MDBDropdown>
                                        <MDBDropdownToggle nav caret>
                                            <span
                                                className="mr-2"
                                                onClick={this.click}
                                            >
                                                {this.props.selectedKeyName ===
                                                null
                                                    ? this.props.firstKeyName
                                                    : this.props
                                                          .selectedKeyName}
                                            </span>
                                        </MDBDropdownToggle>
                                        <MDBDropdownMenu>
                                            {this.props.keyNameListArray.map(
                                                (value, index) => {
                                                    return (
                                                        <MDBDropdownItem
                                                            onClick={(e) =>
                                                                this.props.updateNameKey(
                                                                    keyNameListArray[
                                                                        index
                                                                    ][1],
                                                                    keyNameListArray[
                                                                        index
                                                                    ][0]
                                                                )
                                                            }
                                                        >
                                                            {
                                                                keyNameListArray[
                                                                    index
                                                                ][1]
                                                            }
                                                        </MDBDropdownItem>
                                                    );
                                                }
                                            )}
                                        </MDBDropdownMenu>
                                    </MDBDropdown>
                                </div>
                                <div className="col-sm-2 formControls">
                                    <MDBIcon
                                        icon="edit"
                                        onClick={this.toggleEditNickname}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-4">
                                    <p>
                                        <strong>
                                            {t("profiledetails.network")}
                                        </strong>
                                    </p>
                                </div>
                                <MDBDropdown className="col-sm-6">
                                    <MDBDropdownToggle nav caret>
                                        <span className="mr-2">
                                            {this.props.ssidName}
                                        </span>
                                    </MDBDropdownToggle>
                                    <MDBDropdownMenu>
                                        {this.props.SessionList.map(
                                            (value, index) => {
                                                return (
                                                    <MDBDropdownItem
                                                        onClick={(e) =>
                                                            this.props.updateNameNetwork(
                                                                this.props
                                                                    .SessionList[
                                                                    index
                                                                ][0]["ssid"],
                                                                index
                                                            )
                                                        }
                                                    >
                                                        {
                                                            this.props
                                                                .SessionList[
                                                                index
                                                            ][0]["ssid"]
                                                        }
                                                    </MDBDropdownItem>
                                                );
                                            }
                                        )}
                                    </MDBDropdownMenu>
                                </MDBDropdown>
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text col-form-label"
                                        >
                                            <strong>
                                                {t("profiledetails.password")}
                                            </strong>{" "}
                                            {this.state.showPassword !==
                                            true ? (
                                                <MDBIcon
                                                    icon="eye"
                                                    onClick={
                                                        this.togglePassword
                                                    }
                                                />
                                            ) : (
                                                <MDBIcon
                                                    icon="eye-slash"
                                                    onClick={
                                                        this.togglePassword
                                                    }
                                                />
                                            )}
                                        </label>
                                    </div>
                                    <div className="col-sm-6">
                                        <p
                                            className="inputBox"
                                            id="password"
                                            style={{ marginBottom: 0 }}
                                        >
                                            {this.state.showPassword !== false
                                                ? password === null
                                                    ? this.props.firstPSK
                                                    : password
                                                : "************"}
                                        </p>
                                        <span id="passwordHidden">
                                            {password === null
                                                ? this.props.firstPSK.split(
                                                      "."
                                                  )[1] === undefined
                                                    ? this.props.firstPSK
                                                    : this.props.firstPSK
                                                : password}
                                        </span>
                                    </div>
                                    <div className="col-sm-2 formControls" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {/* WPA3 Status Badge */}
                                        {wpa3Status.isWPA3 ? (
                                            wpa3Status.configured ? (
                                                <span
                                                    title="Password is active"
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        minWidth: '20px',
                                                        minHeight: '20px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '14px',
                                                        fontWeight: 'bold',
                                                        cursor: 'help',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                </span>
                                            ) : (
                                                <span
                                                    title="Password not configured"
                                                    style={{
                                                        backgroundColor: '#6c757d',
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        minWidth: '20px',
                                                        minHeight: '20px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '16px',
                                                        fontWeight: 'bold',
                                                        cursor: 'help',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                </span>
                                            )
                                        ) : (
                                            ""
                                        )}
                                        <MDBIcon
                                            icon="edit"
                                            onClick={
                                                this.toggleEditPassword
                                            }
                                        />
                                        <MDBIcon
                                            icon="copy"
                                            onClick={this.copyPassword}
                                        />
                                    </div>
                                </div>
                            </div>
                        </MDBCol>
                        <MDBCol sm="6">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <p>
                                            <strong>
                                                {t("profiledetails.activated")}
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="col-sm-8">
                                     <p>
                                        {this.state.addedOn}
                                     </p>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <p>
                                            <strong>
                                                {t("profiledetails.recentuse")}
                                            </strong>
                                        </p>
                                    </div>
                                    <div className="col-sm-8">
                                     <p>
                                        {this.state.recentUse}
                                     </p>
                                    </div>
                                </div>
                            </div> */}
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol sm="12">
                            <p>
                                <strong>Subscriptions</strong>
                            </p>
                            <AllWifiKeysTable
                                venueUnitPolicyInfo={
                                    this.props.venueUnitPolicyInfo
                                }
                            />
                        </MDBCol>
                    </MDBRow>
                    <br />
                    {
                     !this.props.isUbiquiti ? (
                    
                    <MDBRow>
                        <MDBCol sm="6">
                            <p>
                                <strong>{t("profiledetails.devices")}</strong>
                            </p>
                            <div>
                                {Object.keys(this.props.devices).length > 0 ? (
                                    <div
                                        className="devices"
                                        style={{
                                            border: "1px solid #CCC",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            minHeight: "232px",
                                        }}
                                    >
                                        {Object.keys(this.props.devices)
                                            .slice(0, 3)
                                            .map((oneKey, i) => {
                                                return (
                                                    <div
                                                        className="deviceCard"
                                                        onClick={(e) =>
                                                            this.toggleDeviceDetails(
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ]
                                                            )
                                                        }
                                                    >
                                                        <MDBIcon
                                                            icon={this.renderDeviceIcon(
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ]["DeviceType"]
                                                            )}
                                                        />
                                                        <div
                                                            className={
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ][
                                                                    "currentlyOnline"
                                                                ] === true
                                                                    ? "deviceStatusConnected"
                                                                    : "deviceStatusDisconnected"
                                                            }
                                                        ></div>
                                                        <p>
                                                            {
                                                                this.props
                                                                    .devices[
                                                                    oneKey
                                                                ][
                                                                    "UserDefinedHostName"
                                                                ]
                                                            }
                                                        </p>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                ) : (
                                    <MDBCard
                                        style={{
                                            border: "1px solid #CCC",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            minHeight: "232px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <MDBCardBody
                                            className="messageCardBody1"
                                            style={{ flex: "unset" }}
                                        >
                                            <h4 style={{ color: "#BBB" }}>
                                                No devices to display yet
                                            </h4>
                                        </MDBCardBody>
                                    </MDBCard>
                                )}
                            </div>
                        </MDBCol>
                        <MDBCol sm="6">
                            <p>
                                <strong>{t("profiledetails.bandwidth")}</strong>
                            </p>
                            <div
                                style={{
                                    border: "1px solid #CCC",
                                    padding: "10px",
                                    borderRadius: "5px",
                                }}
                            >
                                <Data
                                    selectedKeyID={this.props.keyIDForBandwith}
                                />
                            </div>
                        </MDBCol>
                    </MDBRow>
                     ) : ""
                  }
                </MDBModalBody>
                <MDBModalFooter>
                    <div className="text-right">
                        <MDBBtn
                            color="danger"
                            onClick={this.props.toggleManageKey}
                        >
                            OK
                        </MDBBtn>
                    </div>
                </MDBModalFooter>
            </>
        );
    }
}
export default withTranslation()(KeyManage);
